import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {SeleccionInformesContainer} from './Screen';

export const SeleccionInformesView = () =>{

    return (
        <Page title={'Gestion DNs - Informes'} scrollBody>{<SeleccionInformesContainer/>}</Page>
    )
}